import { defineNuxtPlugin } from '#app/nuxt'
import { LazyIcon, LazyNuxtIcon } from '#components'
const lazyGlobalComponents = [
  ["Icon", LazyIcon],
["NuxtIcon", LazyNuxtIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
